import React from 'react';
import { Attributes } from '@leverege/ui-attributes';
import { GoogleGeoShapeRenderer } from '@leverege/molten/data-viewers';
import { Relationship, GroupDelegate, MapUtil as Util } from '@leverege/molten/imagine';
import FilterableZoneGeoShapeModel from "./FilterableZoneGeoShapeModel.js";
import FilterableZoneLoaderLayer from "./FilterableZoneLoaderLayer.js";
import FilterableZoneLoadDataRenderer from "./FilterableZoneLoadDataRenderer.js";
const SUPPORTED_LAYER_KEYS = ['rooms'];
function processRelationship(molten, relationship, options) {
  const {
    attribute,
    parentRelationship: pRel,
    blueprint,
    path
  } = relationship;
  if (attribute == null) {
    addBlueprintMapLayers(molten, blueprint);
  }
  if (attribute && blueprint.type === 'zone') {
    // Show these objects in its siblings' views. This means adding layers at paths for 
    // this attributes' containing/parent blueprint's attributes

    const siblings = attribute.blueprint.attributes.filter(a => a != attribute && a.isRelationship()) // eslint-disable-line eqeqeq
    .map(a => `${pRel.path}.${a.path}`);

    // What about grand-aunts/uncles
    if (siblings.length > 0) {
      const nShapes = Attributes.getAttributesFor(blueprint.type).filter(attr => attr.valueType === 'geoJson');
      nShapes.forEach(uiAttr => {
        const shapeAttr = uiAttr.blueprint.attribute;
        const model = FilterableZoneGeoShapeModel;
        const renderer = GoogleGeoShapeRenderer;
        const shapePath = shapeAttr.path.replace(/\//g, '.');
        const layerName = `${path}.${shapePath}.FilterableZone`;
        const modelName = nShapes.length === 1 ? `${blueprint.namePlural} ${shapeAttr.name} with Filters` : `${pRel.blueprint.name} ${attribute.name} ${shapeAttr.name} with Filters`;
        molten.addPlugin('GoogleMapsRenderer', {
          id: `blueprint.${layerName}.${path}.google.FilterableZoneGeoShapeRenderer`,
          matches: {
            client: 'GoogleMapsDataViewer',
            path: (all, val) => {
              // works for all siblings or ancestors
              return val !== path && val?.length > pRel.path.length && val?.startsWith(pRel.path) || siblings.indexOf(val) >= 0;
            }
          },
          layerName,
          sort: 'zzz',
          createModel: Util.newModelCreator(model, {
            objectType: blueprint.type,
            layerName,
            name: modelName
          }, {
            attrName: uiAttr.name
          }),
          create: props => {
            const {
              relationship,
              delegate
            } = props;
            const ancestor = Relationship.getByPath(pRel.path);
            if (ancestor == null) {
              // eslint-disable-next-line no-console
              console.warn('Expected to find ancestor relationship but didnt', pRel.path, relationship);
              return null;
            }
            let sRel = Relationship.getByPath(path);
            sRel = sRel.createResolved(delegate.match);
            const ancestorActions = new GroupDelegate({
              match: delegate.match,
              relationship: sRel
            });
            return /*#__PURE__*/React.createElement(FilterableZoneLoadDataRenderer, {
              ...props,
              renderer,
              delegate: ancestorActions,
              key: layerName,
              relationship: sRel,
              attributeName: uiAttr.name,
              attribute: shapeAttr
            });
          }
        });
      });
    }
  }
}
function addBlueprintMapLayers(molten, blueprint) {
  const meta = blueprint.metadata;
  const mapLayers = meta?.mapLayers;
  if (mapLayers) {
    Object.keys(mapLayers).forEach(layerKey => {
      const layer = mapLayers[layerKey];
      if (SUPPORTED_LAYER_KEYS.includes(layerKey)) {
        molten.addPlugin('GoogleMapsRenderer', FilterableZoneLoaderLayer.create({
          blueprint,
          layer,
          layerKey
        }));
      }
    });
  }
}
export default {
  id: 'recovr.BlueprintGoogleMapsRendererCreator',
  processRelationship
};